<template>
	<div>
		<datos-generales :datosPaciente="datosPaciente"></datos-generales>
		<router-view></router-view>
	</div>
</template>

<script>
import ServicioVisita from "../../../services/visita";
import DatosGenerales from "./DatosGenerales.vue";
export default {
	components: { DatosGenerales },
	name: "visita",
	async mounted() {
		await this.obtenerInfoPaciente();
	},
	data() {
		return {
			datosPaciente: {}
		};
	},
	methods: {
		async obtenerInfoPaciente() {
			const res = await ServicioVisita.obtenerInfoPaciente(this.visitaId);
			if (res.data.data && res.data.data.Table0.length) {
				this.datosPaciente = res.data.data.Table0[0];
				this.$root.edad = this.datosPaciente.Edad;
			}
		}
	},
	computed: {
		visitaId() {
			return this.$route.params.visitaId;
		}
	}
};
</script>

<style></style>
